import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.scss';
import HomeHeader from './header/header.js';
import HomeContent from './inbox/inbox.js'
import queryString from "query-string";
import { Redirect } from 'react-router-dom'

function Index(props) {
  const [isRedirect, setIsRedirect] = useState(false);

  useEffect(() => {
    const { companyName, userPhone } = sessionStorage;
    if (!companyName || !userPhone) setIsRedirect(true);

    checkPhone();
    checkCompanyName();
  }, []);

  const checkPhone = () => {
    const { userPhone } = sessionStorage;
    // 判断当前手机号码是否注册
    axios({
      method: 'POST',
      url:"/user-center/account/checkAccountNo.ajax",
      headers: {'Content-Type': 'application/x-www-form-urlencoded'}, // application/x-www-form-urlencoded
      data: queryString.stringify({tel: Number(userPhone)})
    }).then((res) => {
      if (res.data.status === 0) throw '该手机号已注册!';
    }).catch(() => {
      setIsRedirect(true);
    })
  }

  const checkCompanyName = () => {
    const { companyName } = sessionStorage;
    // 判断当前公司名是否存在
    axios({
      method: 'post',
      url:"/user-center/account/checkCompayName.ajax",
      headers: {'Content-Type': 'application/x-www-form-urlencoded'}, // application/x-www-form-urlencoded
      data:  queryString.stringify({ companyName })
    }).then((res) => {
      if (res.data) throw '该企业已注册！';
    })
    .catch((res) => {
      setIsRedirect(true);
    })
  }

  if (isRedirect) {
    return (
      <Redirect to = '/' />
    )
  };

  return (
    <Router>
      <div className="home-root">
        {/* <aside className="aside-wrapper"> */}
        {/* </aside> */}
        <section className="section-wrapper">
            <HomeHeader />
            <HomeContent />
        </section>
      </div>
    </Router>
  );
}

export default Index;
